module.exports = __webpack_public_path__ + "fonts/Optima-ExtraBlack.f9871588.ttf";